import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  borderRadius8,
  standardFocusStateInset,
} from 'approot/shared/styles/borders.style';
import { grey7, grey8 } from 'approot/shared/styles/colours.style';
import { spacing16, spacing20 } from 'approot/shared/styles/spacing.style';
import {
  fontSize12,
  fontSize12LineHeight,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';

export const NavigationMenuIconButton = styled.button`
  background: none;
  border: none;
  border-radius: ${rem(borderRadius8)};
  color: ${grey7};
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${rem(fontSize12)};
  font-weight: ${fontWeightMedium};
  line-height: ${rem(fontSize12LineHeight)};
  position: absolute;
  left: ${rem(spacing16)};
  top: ${rem(spacing20)};

  ${standardFocusStateInset}

  &:focus {
    color: ${grey8};
  }
  &:focus:not(:focus-visible) {
    color: ${grey7};
  }
  &:focus-visible {
    color: ${grey8};
  }

  svg {
    margin-bottom: ${rem(2)};
    stroke-width: 1.5;
  }
`;
